const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
    api: "https://vsip-api.vietnamiz.com/",
    media_url: "https://vsip-api.vietnamiz.com/",
    domainAdminSide: "http://localhost:3000",
    domainUserSide: "http://localhost:3001",
    domainName: "",
    workSpace: "vsip",
    wmsBaseLink: "https://geo.cgis.asia/geoserver/vsip/wms/",
  },
  production: {
    api: "https://vsip-api.vietnamiz.com/",
    media_url: "https://vsip-api.vietnamiz.com/",
    domainUserSide: "https://vsip.vietnamiz.com",
    domainAdminSide: "https://admin.vsip.vietnamiz.com",
    domainName: "vsip.vietnamiz.com",
    workSpace: "vsip",
    wmsBaseLink: "https://geo.cgis.asia/geoserver/vsip/wms/",
  },
};

module.exports = apiEnvironment[env];
